import { render } from "./App.vue?vue&type=template&id=d0a2ed5a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=d0a2ed5a&lang=scss"

import exportComponent from "E:\\vueapp\\xm-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__